import { render, staticRenderFns } from "./VAdministrationFloorsTable.vue?vue&type=template&id=935a5e58&"
import script from "./VAdministrationFloorsTable.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationFloorsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports